import { createContext, useContext } from 'react'
import PropTypes from 'prop-types' // Import PropTypes
import useOutsideClick from '../hooks/useOutsideClick'

const SidebarContext = createContext()

export const SidebarProvider = ({ children }) => {
  const {
    dropdownRef: sideBarRef,
    isDropdownOpen: isSidebarOpen,
    setIsDropdownOpen: setSidebarOpen,
  } = useOutsideClick()

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev)
  }

  return (
    <SidebarContext.Provider
      value={{ sideBarRef, isSidebarOpen, toggleSidebar }}
    >
      {children}
    </SidebarContext.Provider>
  )
}

//  Add PropTypes validation
SidebarProvider.propTypes = {
  children: PropTypes.node.isRequired, // Ensures 'children' is passed and is a valid React node
}

export const useSidebar = () => useContext(SidebarContext)
